import * as React from 'react'
import { createContext, useCallback, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { useTabIndexes } from './hooks'

const TabsGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;

  @media screen and (max-width: 480px) {
    gap: 1.5rem;
  }
`

export const TabsNavigation = styled.nav<{
  position?: 'left' | 'center'
}>`
  align-items: center;
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  overflow-x: auto;
  padding: 0.2rem 0.2rem 1rem 0.2rem;
  margin: -0.2rem -0.2rem -1rem -0.2rem;
  gap: 0.2rem;

  > button:first-child {
    margin-left: ${({ position }) => position !== 'left' && 'auto'};
  }
  > button:last-child {
    margin-right: ${({ position }) => position !== 'left' && 'auto'};
  }
`

export interface TabsContextValue {
  activeTabId: string
  setActive: (tabId: string) => void
  registerTab: (tabId: string) => void
  unregisterTab: (tabId: string) => void
}

export const TabsContext = createContext<TabsContextValue>({
  activeTabId: '',
  setActive: () => { },
  registerTab: () => { },
  unregisterTab: () => { },
})

export interface TabsWrapperProps {
  children: React.ReactNode
  autoplay?: boolean
}

export const TabsWrapper = ({ children, autoplay }: TabsWrapperProps) => {
  const { registerTab, tabId, tabIds, unregisterTab, setTabId, setTabIds, onMouseEnter, onMouseLeave } = useTabIndexes({
    autoplay,
  })

  return (
    <TabsContext.Provider value={{ activeTabId: tabId, setActive: setTabId, registerTab, unregisterTab }}>
      <TabsGroup onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
        {children}
      </TabsGroup>
    </TabsContext.Provider>
  )
}
